import { recommendationSVC as Recommendation } from '@com/core/common/services/api';
import { TCatalogResponse } from '../types/catalog';
import { TLocale } from '../types/locale';
import { TRecommendationsPOST } from '../types/recommendation';
import { reportEvent } from './sentry';

type TProps = {
    event: TRecommendationsPOST['event'];
    catalogData: TCatalogResponse;
    locale: TLocale;
};

export const getRecommendationSkus = async ({ catalogData, event, locale }: TProps): Promise<string[]> => {
    try {
        let params = {
            event,
        };

        switch (event) {
            // TODO
            case 'page_cart': {
                params = {
                    ...params,
                };
                break;
            }
            case 'page_detail': {
                params = {
                    ...params,
                    skuConfig: catalogData.product.sku,
                };
                break;
            }
            case 'page_static': {
                params = {
                    ...params,
                    path: catalogData.canonical_url,
                };
                break;
            }
            default: {
                return [];
            }
        }

        const { data } = await Recommendation(locale.apiLocale).ingest(event, params);

        return data.results.map(r => r.catalogItemId);
    } catch (e) {
        reportEvent('Could not fetch recommendation skus', 'getRecommendationSkus()');
        return [];
    }
};
